export const StakedIcon = ({ size = 32, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M10.6668 18.6667C15.0851 18.6667 18.6668 15.085 18.6668 10.6667C18.6668 6.24847 15.0851 2.66675 10.6668 2.66675C6.24853 2.66675 2.66681 6.24847 2.66681 10.6667C2.66681 15.085 6.24853 18.6667 10.6668 18.6667Z"
      stroke="#D4AF37"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.1201 13.8267C25.3805 14.2966 26.5021 15.0767 27.3811 16.0949C28.2601 17.1131 28.8682 18.3366 29.1491 19.6521C29.43 20.9676 29.3746 22.3327 28.9881 23.6211C28.6017 24.9096 27.8965 26.0798 26.938 27.0235C25.9794 27.9672 24.7984 28.654 23.5041 29.0203C22.2097 29.3866 20.8439 29.4207 19.533 29.1193C18.222 28.8179 17.0082 28.1908 16.0038 27.296C14.9995 26.4012 14.2369 25.2676 13.7867 24"
      stroke="#D4AF37"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.33319 8H10.6665V13.3333"
      stroke="#D4AF37"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.2802 18.5066L23.2135 19.4533L19.4535 23.2133"
      stroke="#D4AF37"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
